import constants from "../constants";

const initialState = {
  allSkills: [],
};

const adminStore = (state = initialState, action) => {
  switch (action.type) {
    case constants.adminActions.fetchAllSkills:
      return {
        ...state,
        allSkills: action.allSkills,
      };
    default: {
      return { ...state };
    }
  }
};

export default adminStore;
